import { redirect } from "react-router";
import { bootstrapAuth } from "@/auth/me";
import { loginUrlFor } from "@/auth/login-url";
import { hasSystemAccess } from "@/auth/roles";
import { useAuthStore } from "@/stores/auth-store";

// React Router data router loader. Used on every protected route.
// Cheap: if the auth store already says we're authenticated, returns
// immediately. Only hits /auth/me when status is still "loading"
// (first navigation) or after an explicit invalidation.
//
// On anonymous: throws a redirect to /auth/login with the current
// URL as `next=` so post-login navigation lands where the user tried
// to go.

export async function requireAuth({ request }: { request: Request }): Promise<null> {
  const state = useAuthStore.getState();
  if (state.status === "loading") {
    await bootstrapAuth();
  }
  const after = useAuthStore.getState();
  if (after.status !== "authenticated") {
    const url = new URL(request.url);
    throw redirect(loginUrlFor(url.pathname + url.search));
  }
  return null;
}

// Route loader for the Systemeinstellungen surface. Runs requireAuth first
// (redirects anonymous users to login), then redirects authenticated users
// without any system-settings privilege to the app root. genesis still
// enforces every write server-side; this just keeps the pages out of reach.
export async function requireSystemAccess(args: { request: Request }): Promise<null> {
  await requireAuth(args);
  const { profile } = useAuthStore.getState();
  if (!hasSystemAccess(profile?.roles)) {
    throw redirect("/");
  }
  return null;
}
